<template>
    <div class="background bg-primary-color">
        <div :style="url(background)" class="background__img w-full h-full flex justify-end items-center bg-no-repeat bg-center bg-cover m-auto">
            <slot/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Background',
    setup() {
        const background = 'https://down-th.img.susercontent.com/file/sg-11134004-7rd71-lvoblegd0n0l33'

        return{
            background
        }
    },
    methods: {
        url: function (url) {
            return `background-image: url(${url});`;
        }
    }
}
</script>

<style scoped>
.background{
    height: 60rem;
}

.background__img{
    height: 60rem;
    width: 104rem;
    min-height: 60rem;
}

@media (max-width: 1100px){
    .background__img{
        justify-content: center;
        width: 100%;
    }
    
}
</style>